import { Component } from '@angular/core';
import { SharedAnalyticsService } from '../../../analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsHeaderLabels } from '../../../enums/analytics.enum';
import { SECTIONS } from '../../../models/Constants';

@Component({
  selector: 'getm-menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss']
})
export class MenuButtonComponent {

  constructor(private sharedAnalyticsS: SharedAnalyticsService) { }

  //TODO cuando el menu se integre en otras pantallas, ver de donde se extrae section
  public onClickMenu(): void {
    this.sharedAnalyticsS.trackInteractionHeader({
      section: SECTIONS.TIENDA,
      label: EAnalyticsHeaderLabels.MENU
    });
  }
}
